import UserTable from './_components/users-table'
import AddMemberModal from './_components/add-user'

export default function UserPage() {
  return (
    <div className="w-full">
      <div className="flex flex-row justify-between w-full">
        <h1 className="text-2xl md:text-[32px] font-bold mb-2">User List</h1>
        <AddMemberModal />
      </div>
      <UserTable />
    </div>
  )
}
